import React, { useState, useMemo, useEffect } from "react";
import {
  Nav,
  NavbarToggler,
  NavItem,
  NavLink,
  Container,
  Collapse,
} from "reactstrap";
import { Link } from "react-router-dom";
import ScrollspyNav from "./Scrollspy";

const NavbarPage = ({ navItems = [], navClass = "" }) => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const toggle = () => setIsOpenMenu((prev) => !prev);

  // ambil id untuk scrollspy
  const targetId = useMemo(
    () => navItems.map((item) => item.idnm),
    [navItems]
  );

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);  

  return (
    <nav
      className={` navbar navbar-expand-lg navbar-custom sticky sticky-main fixed-top ${navClass} navbar-custom ${scrolled ? "scrolled" : ""} `}
      id="navbar"
    >
      <Container>
        <Link to="#" className="navbar-brand">
          <img 
            src="assets/images/main-logo.webp" 
            alt="logo-niec-indonesia" 
            />
          <img
            src="assets/images/logo-1.webp"
            className="ms-2"
            alt="logo-melbourne-poly-niec-indonesia's-platinum-member"
          />
        </Link>

        <NavbarToggler onClick={toggle}>
          <span className="ti-menu"></span>
        </NavbarToggler>

        <Collapse
          id="navbarCollapse"
          isOpen={isOpenMenu}
          className="navbar-collapse"
        >
          <ScrollspyNav
            scrollTargetIds={targetId}
            scrollDuration="800"
            headerBackground="true"
            activeNavClass="active"
            className="navbar-collapse"
          >
            <Nav className="navbar-nav mx-auto" id="navbar-navlist">
              {navItems.map((item) => (
                <NavItem
                  key={item.id}
                  className={item.navheading === "Beranda" ? "active" : ""}
                >
                  <NavLink
                    className={item.navheading === "Beranda" ? "active" : ""}
                    href={`#${item.idnm}`}
                  >
                    {item.navheading}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </ScrollspyNav>
        </Collapse>
      </Container>
    </nav>
  );
};

export default NavbarPage;